// COPY dictionary for the Features landing (EN + ES) — extracted from
// FeaturesProof.jsx to enable shared use across /design-proof/features
// and the production V2 landing (behind LEVI_LANDING_V2_ENABLED).
// No text, no key changes vs the design-proof reference.

export const COPY = {
  en: {
    nav: { how: "How it works", features: "Features", pricing: "Pricing", story: "Our Story", signin: "Sign in", demo: "Schedule a Demo" },
    tagline: "The AI Operating System for Contractors",
    hero: {
      h1a: "Meet Levi.", h1b: "Your AI coworker.",
      lede: "Levi helps contractors understand the job, win the work, keep projects moving, handle paperwork, and get paid — without adding more work to your day.",
      bullet1: "Built by a contractor, for contractors",
      bullet2: "Works in English and Spanish",
      bullet3_title: "One experience. Two languages.",
      bullet3_sub: "Use JobClose AI in English or Spanish — you choose.",
      cta: "Schedule a Demo",
      martha_voice: "Levi, email Martha over her invoice for the roof we just completed.",
      martha_reply_pre: "Okay, emailing the invoice to",
      martha_name: "Martha Johnson.",
      inv_label: "Invoice #INV-1047",
      inv_amount: "$7,450.00",
      inv_body_line1: "Roof Replacement at 2405 Maple Ave.",
      inv_body_line2: "Balance due: $7,450.00",
      inv_email_label: "Email",
      inv_status_sent: "Sent",
      inv_email_addr: "martha.johnson@email.com",
      inv_email_meta: "Orlando, FL 32801 · Today, 5:09 PM",
      inv_view: "View Invoice",
      recommends: "Levi recommends. You decide.",
    },
    understand: {
      h2a: "Levi understands", h2b: "every job.",
      lede: "Tell Levi what you saw, upload photos or videos, share documents, add measurements — Levi turns chaos into a clear, organized job record so nothing gets missed.",
      voice_title: "Voice Notes",
      voice_body: "Tell Levi what you saw on site in your own words.",
      photos_title: "Photos & Video",
      photos_body: "Show Levi the job so he sees exactly what you see.",
      docs_title: "Documents",
      docs_body: "Plans, permits, contracts, or anything important.",
      meas_title: "Measurements",
      meas_body: "Levi Vision verifies your measurements for accuracy.",
      meas_area_label: "Total Area",
      meas_badge_title: "Levi Vision",
      meas_badge_sub: "for accuracy",
      meas_badge_status: "Verified",
      obs_title: "Observations",
      obs_body: "Details, conditions, preferences, and special instructions.",
      obs1: "Homeowner wants dark shingles",
      obs2: "Replace damaged soffit",
      obs3: "Protect landscaping",
      cta: "Schedule a Demo",
      built: "Built by a contractor, for contractors.",
    },
    win: {
      h2a: "Win", h2b: "more work.",
      leader: "Turn organized job information into professional documents that win.",
      lede: "Levi builds accurate estimates, polished proposals, and ready-to-sign contracts—so you look professional, charge with confidence, and close more jobs.",
      c1_title: "Accurate Estimates",
      c1_body: "Levi organizes the job, applies your pricing, and builds detailed estimates.",
      c1_metric_label: "Estimate Total",
      c2_title: "Professional Proposals",
      c2_body: "Beautiful proposals that show value, build trust, and help you stand out.",
      c2_status: "Ready to send",
      c3_title: "Contracts & eSignatures",
      c3_body: "Ready-to-sign contracts with your terms, protect your business and get paid.",
      c3_status: "Signed",
      pricing_a: "Your pricing.", pricing_b: "Levi organizes", pricing_c: "it.",
      pricing_sub: "You stay in control. Levi handles the busy work.",
      prog_est_title: "Estimate",
      prog_est_line: "Roof Replacement",
      prog_est_materials: "Materials",
      prog_est_labor: "Labor",
      prog_est_profit: "Profit",
      prog_est_total: "Total",
      prog_prop_title: "Proposal",
      prog_prop_status: "Ready to send",
      prog_prop_body: "Professional proposal for your customer.",
      prog_con_title: "Contract",
      prog_con_status: "eSigned",
      prog_con_body: "Legally protect your business and get paid.",
      value: [
        { t: "Professional. Consistent. You.", b: "Every document reflects your brand and builds customer confidence." },
        { t: "Save hours every week", b: "Levi handles the details so you can focus on the work." },
        { t: "Fewer mistakes. More profit.", b: "Accurate scope and pricing mean better jobs and fewer change orders." },
        { t: "Get paid faster", b: "Clear proposals. Signed contracts. On time, every time." },
      ],
    },
    keep: {
      h2a: "Keep jobs", h2b: "moving.",
      lede: "Levi keeps your projects on track by managing schedules, sending updates, sharing documents, and making sure nothing falls through the cracks.",
      c1_title: "Calendar & Reminders",
      c1_body: "See what's coming up and get reminded so you never miss a commitment.",
      c1_when: "Tomorrow",
      c1_time: "8:00 AM",
      c1_meta: "Flooring Install · 2405 Maple Ave.",
      c2_title: "Customer Updates",
      c2_body: "Levi sends updates and reminders by email or text—so your customers always know what's next.",
      c2_status: "Sent",
      c3_title: "Work Orders & Field Docs",
      c3_body: "Send work orders, material lists, and instructions to your crew in seconds.",
      c3_label: "Work Order",
      c3_label2: "#WO-1298",
      c4_title: "Crew Coordination",
      c4_body: "Share the right info with the right people—no more chasing anyone down.",
      c5_title: "Job Activity & Status",
      c5_body: "Levi tracks what's done, what's pending, and what needs your attention.",
      c5_progress: "Progress",
      c5_next: "Next: Final Inspection",
      martha_voice: "Levi, text Martha and let her know the crew will be there at 8 tomorrow morning.",
      martha_to: "To: Martha Johnson",
      martha_phone: "(407) 555-0148",
      sms_pill: "SMS",
      sms_body: "Hi Martha, just confirming the crew will be there tomorrow morning at 8:00 AM.",
      sms_sent: "Message sent",
      sms_time: "5:44 PM",
      cal_title: "Job Calendar",
      cal_range: "May 20 – May 26, 2025",
      cal_week: "Week", cal_month: "Month",
      cal_days: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
      cal_evts: ["Flooring", "Site Visit", "Material", "Inspection", "Cust Call", "Walkthru"],
      manuel_voice: "Levi, email Manuel the work order in Spanish, please.",
      manuel_to: "To: Manuel García",
      manuel_role: "Crew Lead",
      manuel_email_pill: "Email",
      // Manuel's message body remains in Spanish because it demonstrates
      // RECIPIENT language — the contractor is instructing Levi to deliver
      // a work order in Spanish. This is intentionally unchanged when
      // page language flips.
      manuel_body_pre: "Ready to send",
      manuel_body_who: "Manuel García",
      manuel_body_what: "Work Order #WO-1298",
      manuel_body_language: "in Spanish.",
      manuel_body_es_verbatim: "Listo para enviar a Manuel García el Work Order #WO-1298 en español.",
      manuel_confirm: "Confirm & Send",
      value: [
        { t: "Stay on schedule.", b: "Levi manages your calendar and reminds you what's coming up." },
        { t: "Keep customers informed.", b: "Updates and reminders go out automatically—by email or text." },
        { t: "Equip your crew.", b: "Send work orders, checklists, and instructions in seconds." },
        { t: "Never miss a thing.", b: "Levi tracks activity and flags what needs your attention." },
        { t: "Jobs keep moving.", b: "Less back-and-forth. More done. More profit." },
      ],
    },
    handle: {
      h2a: "Handle the", h2b: "business.",
      lede: "Levi helps you get paid, track profitability, close out jobs, and keep your business strong and growing.",
      c1_title: "Invoices & Payments",
      c1_body: "Send professional invoices, record payments outside the app, and track what's owed.",
      c2_title: "Profitability Insights",
      c2_body: "Know exactly how each job performed in real time.",
      c3_title: "Closeout Documents",
      c3_body: "Create and send complete project closeout documentation.",
      c4_title: "Warranties & Follow-Up",
      c4_body: "Store warranties, deliver them when needed, and manage post-job follow-up.",
      cta: "Schedule a Demo",
      voice: "Levi, what was our profitability on the Jones exterior re-stucco?",
      reply_pre: "You finished the",
      reply_mid: "Jones job at a 31.6% margin",
      reply_post: ", with",
      reply_profit: "$5,930 in profit",
      reply_end: ".",
      panel_title: "Jones Exterior Re-Stucco",
      panel_status: "Completed",
      panel_contract: "Contract",
      panel_actual: "Actual Cost",
      panel_profit: "Profit",
      panel_margin_label: "Profit Margin",
      panel_date_label: "Job Date",
      panel_date_value: "May 5 – May 28, 2025",
      panel_customer_label: "Customer",
      panel_customer_value: "Jones",
      invoices_title: "Recent Invoices",
      invoices_view: "View all",
      inv_paid: "Paid",
      inv_partial: "Partial",
      inv_unpaid: "Unpaid",
      inv_names: {
        i1: "Jones Exterior Re-Stucco",
        i2: "Smith Roof Replacement",
        i3: "Anderson Interior Paint",
      },
      value: [
        { t: "Get paid faster.", b: "Send professional invoices and track payments recorded outside the app." },
        { t: "Know your numbers.", b: "Real-time insights show profitability by job, customer, and time period." },
        { t: "Close with confidence.", b: "Create complete closeout documents and keep every job documented." },
        { t: "Protect your work.", b: "Store warranties, deliver them automatically, and strengthen customer trust." },
        { t: "Build a stronger business.", b: "Better visibility. Higher profits. Happier customers. More growth." },
      ],
    },
    talk: {
      h2a: "Talk to Levi.", h2b_pre: "Show him", h2b_blue: "the job.",
      lede: "Talk naturally by voice or text while Levi Vision helps you capture and understand what's happening on the job. Walk the project, take photos and video, give Levi your measurements, and have him help verify them and identify what may be missing.",
      c1_title: "Voice & Text",
      c1_body: "Talk naturally, get answers, and keep working.",
      c2_title: "Hands-Free",
      c2_body: "Use voice on the jobsite while your hands stay free.",
      c3_title: "English & Spanish",
      c3_body: "Levi speaks your language.",
      c4_title: "Levi Vision",
      c4_body: "Walk the job, capture photos and video, and add notes.",
      c5_title: "Verify Measurements",
      c5_body: "Check measurements and confirm what looks right.",
      c6_title: "Identify Gaps",
      c6_body: "Levi helps spot what may be missing before it costs you.",
      cta: "Schedule a Demo",
      contractor_voice: "Levi, I have this wall at about 9 feet 4 inches. Does that look right?",
      levi_verify: "That measurement looks consistent with what I'm seeing.",
      levi_observation: "I also noticed a window opening that may need to be accounted for.",
      chip_bar: ["Voice & Text", "Hands-Free", "English & Spanish", "Photos & Video", "Verify Measurements", "Identify Gaps"],
      opening_title: "Opening Detected",
      opening_kind: "Window Opening",
      opening_size: "Approx. 3' 6\" x 4' 2\"",
    },
    proof_stamp: "DESIGN PROOF · not a production route · Landing.jsx untouched · nav untouched · no commit.",
    demo: {
      eyebrow: "See Levi in action",
      h1: "Watch Levi help you run your business smarter.",
      subhead: "JobClose AI and Levi help contractors save time, win more jobs, and close with confidence. Tell us a little about you and we'll reach out to schedule your personalized demo.",
      hero_img_alt: "Levi, the JobClose AI mascot, wearing his approved JobClose AI cap and Levi collar tag, seated at a contractor's worktable next to a JobClose AI mug, a tape measure and a set of blueprints.",
      bullets: [
        { title: "Save time", body: "Automate the busy work and get hours back." },
        { title: "Win more jobs", body: "Accurate estimates and professional proposals in minutes." },
        { title: "Close with confidence", body: "Stay organized, communicate clearly, and get paid faster." },
      ],
      form_title: "Request a demo",
      form_subtitle: "Tell us a little about you and we'll reach out to schedule your personalized demo.",
      f_full_name: "Full name",
      f_company_name: "Company name",
      f_work_email: "Work email",
      f_phone: "Phone number",
      f_trade: "Trade / primary business type",
      f_state: "State",
      f_preferred_contact: "Preferred contact method",
      f_message: "What would you like to see in the demo?",
      ph_full_name: "Your name",
      ph_company_name: "Your company",
      ph_work_email: "you@company.com",
      ph_phone: "(555) 555-5555",
      ph_trade: "Select your trade",
      ph_state: "Select your state",
      ph_message: "Tell us what's most important to your business…",
      optional: "optional",
      pref_labels: { phone: "Phone call", text: "Text message", email: "Email" },
      submit: "Request a Demo",
      submitting: "Sending…",
      form_privacy_note: "Your information is secure and will never be shared.",
      err_required: "Please fill in this field.",
      err_email: "Please enter a valid work email.",
      err_phone: "Please enter a valid phone number.",
      toast_sent: "Thanks! We received your request.",
      toast_failed: "Something went wrong. Please try again.",
      toast_rate_limited: "Too many requests — please try again shortly.",
      success_title: "Thanks — we've got it.",
      success_body: "Someone from JobClose AI will reach out shortly to schedule your personalized demo at a time that works for you.",
      value_heading: "In your demo, we'll show you:",
      value_tiles: [
        { title: "Your workflow", body: "How JobClose AI fits your process from start to finish." },
        { title: "Key features", body: "The tools that save you time and help your business grow." },
        { title: "Levi in action", body: "See how Levi helps you get answers and take action." },
        { title: "Your questions", body: "We'll focus on what matters most to you." },
      ],
      faq_eyebrow: "Common questions",
      faq_heading: "Frequently Asked Questions",
      faqs: [
        { q: "What will I see during the demo?", a: "We'll focus on how JobClose AI and Levi work across the contractor workflow — from understanding a job to closing it — and spend extra time on the areas you care about most." },
        { q: "How long does a demo take?", a: "Most demos take around 30 minutes. If you have a lot to cover we're happy to go longer." },
        { q: "Who is JobClose AI built for?", a: "Field-based contractors and small crews across trades like roofing, painting, flooring, remodeling, concrete, HVAC, and more. If you estimate, run, and close jobs, JobClose AI is built for you." },
        { q: "Do I need to prepare anything before the demo?", a: "No. Just bring your questions. If there's something specific you'd like to see, let us know in the form and we'll be ready." },
        { q: "Can you show me how Levi would work with my business?", a: "Yes. Levi is a core part of JobClose AI, and we'll show you how contractors use him throughout the day — voice, photos, plans, estimates, proposals, invoices, and follow-ups." },
        { q: "Does JobClose AI work for different trades?", a: "Yes. Your pricing, your trades, your workflow. Levi adapts to how you already run your business rather than forcing a one-size-fits-all template." },
        { q: "What does JobClose AI cost?", a: "JobClose AI is $129/month and includes two full users. Additional users are $20/month each. Standard onboarding is included. There are no artificial feature tiers or required add-ons — you receive the full JobClose AI and Levi experience with everything included." },
      ],
      final_title: "Ready to see Levi work the way you work?",
      final_body: "Fill out the form above and we'll be in touch to schedule your demo.",
      final_cta: "Request a demo",
    },
  },
  es: {
    nav: { how: "Cómo funciona", features: "Funcionalidades", pricing: "Precios", story: "Nuestra Historia", signin: "Iniciar sesión", demo: "Agenda una Demo" },
    tagline: "El sistema operativo con IA para contratistas",
    hero: {
      h1a: "Conoce a Levi.", h1b: "Tu compañero de trabajo con IA.",
      lede: "Levi ayuda a los contratistas a entender el trabajo, ganar más contratos, mantener los proyectos en movimiento, gestionar el papeleo y cobrar — sin agregar más trabajo a tu día.",
      bullet1: "Hecho por un contratista, para contratistas",
      bullet2: "Funciona en inglés y español",
      bullet3_title: "Una experiencia. Dos idiomas.",
      bullet3_sub: "Usa JobClose AI en inglés o español — tú eliges.",
      cta: "Agenda una Demo",
      martha_voice: "Levi, envíale por correo a Martha la factura del techo que acabamos de terminar.",
      martha_reply_pre: "Listo, enviando la factura a",
      martha_name: "Martha Johnson.",
      inv_label: "Factura #INV-1047",
      inv_amount: "$7,450.00",
      inv_body_line1: "Reemplazo de Techo en 2405 Maple Ave.",
      inv_body_line2: "Saldo pendiente: $7,450.00",
      inv_email_label: "Correo",
      inv_status_sent: "Enviado",
      inv_email_addr: "martha.johnson@email.com",
      inv_email_meta: "Orlando, FL 32801 · Hoy, 5:09 PM",
      inv_view: "Ver Factura",
      recommends: "Levi recomienda. Tú decides.",
    },
    understand: {
      h2a: "Levi entiende", h2b: "cada trabajo.",
      lede: "Cuéntale a Levi lo que viste, sube fotos o videos, comparte documentos y añade medidas — Levi convierte el caos en un registro claro y organizado del trabajo para que nada se pierda.",
      voice_title: "Notas de Voz",
      voice_body: "Cuéntale a Levi lo que viste en el sitio con tus propias palabras.",
      photos_title: "Fotos y Video",
      photos_body: "Muéstrale a Levi el trabajo para que vea exactamente lo que tú ves.",
      docs_title: "Documentos",
      docs_body: "Planos, permisos, contratos o cualquier cosa importante.",
      meas_title: "Medidas",
      meas_body: "Levi Vision verifica tus medidas con precisión.",
      meas_area_label: "Área Total",
      meas_badge_title: "Levi Vision",
      meas_badge_sub: "con precisión",
      meas_badge_status: "Verificado",
      obs_title: "Observaciones",
      obs_body: "Detalles, condiciones, preferencias e instrucciones especiales.",
      obs1: "El cliente quiere tejas oscuras",
      obs2: "Reemplazar el sofito dañado",
      obs3: "Proteger el paisajismo",
      cta: "Agenda una Demo",
      built: "Hecho por un contratista, para contratistas.",
    },
    win: {
      h2a: "Gana", h2b: "más trabajos.",
      leader: "Convierte la información organizada del trabajo en documentos profesionales que ganan.",
      lede: "Levi crea estimados precisos, propuestas pulidas y contratos listos para firmar — para que te veas profesional, cotices con confianza y cierres más trabajos.",
      c1_title: "Estimados Precisos",
      c1_body: "Levi organiza el trabajo, aplica tus precios y crea estimados detallados.",
      c1_metric_label: "Total del Estimado",
      c2_title: "Propuestas Profesionales",
      c2_body: "Propuestas bonitas que muestran valor, crean confianza y te hacen destacar.",
      c2_status: "Listo para enviar",
      c3_title: "Contratos y Firmas Electrónicas",
      c3_body: "Contratos listos para firmar con tus términos, para proteger tu negocio y cobrar.",
      c3_status: "Firmado",
      pricing_a: "Tus precios.", pricing_b: "Levi los organiza", pricing_c: "por ti.",
      pricing_sub: "Tú mantienes el control. Levi se encarga del trabajo tedioso.",
      prog_est_title: "Estimado",
      prog_est_line: "Reemplazo de Techo",
      prog_est_materials: "Materiales",
      prog_est_labor: "Mano de Obra",
      prog_est_profit: "Ganancia",
      prog_est_total: "Total",
      prog_prop_title: "Propuesta",
      prog_prop_status: "Listo para enviar",
      prog_prop_body: "Propuesta profesional para tu cliente.",
      prog_con_title: "Contrato",
      prog_con_status: "Firmado",
      prog_con_body: "Protege legalmente tu negocio y asegura tu pago.",
      value: [
        { t: "Profesional. Consistente. Tú.", b: "Cada documento refleja tu marca y genera confianza con el cliente." },
        { t: "Ahorra horas cada semana", b: "Levi se encarga de los detalles para que puedas enfocarte en el trabajo." },
        { t: "Menos errores. Más ganancia.", b: "Alcance y precios precisos significan mejores trabajos y menos cambios de orden." },
        { t: "Cobra más rápido", b: "Propuestas claras. Contratos firmados. A tiempo, siempre." },
      ],
    },
    keep: {
      h2a: "Mantén los trabajos", h2b: "en movimiento.",
      lede: "Levi mantiene tus proyectos avanzando gestionando calendarios, enviando actualizaciones, compartiendo documentos y asegurándose de que nada se te escape.",
      c1_title: "Calendario y Recordatorios",
      c1_body: "Mira lo que viene y recibe recordatorios para nunca perder un compromiso.",
      c1_when: "Mañana",
      c1_time: "8:00 AM",
      c1_meta: "Instalación de Pisos · 2405 Maple Ave.",
      c2_title: "Actualizaciones al Cliente",
      c2_body: "Levi envía actualizaciones y recordatorios por correo o texto — para que tus clientes siempre sepan qué sigue.",
      c2_status: "Enviado",
      c3_title: "Órdenes de Trabajo y Documentos de Campo",
      c3_body: "Envía órdenes de trabajo, listas de materiales e instrucciones a tu equipo en segundos.",
      c3_label: "Orden de Trabajo",
      c3_label2: "#WO-1298",
      c4_title: "Coordinación de Equipo",
      c4_body: "Comparte la información correcta con las personas correctas — sin perseguir a nadie.",
      c5_title: "Actividad y Estado del Trabajo",
      c5_body: "Levi registra qué está listo, qué está pendiente y qué necesita tu atención.",
      c5_progress: "Progreso",
      c5_next: "Siguiente: Inspección Final",
      martha_voice: "Levi, envíale un texto a Martha para avisarle que el equipo llegará a las 8 mañana en la mañana.",
      martha_to: "Para: Martha Johnson",
      martha_phone: "(407) 555-0148",
      sms_pill: "SMS",
      sms_body: "Hola Martha, solo confirmando que el equipo llegará mañana en la mañana a las 8:00 AM.",
      sms_sent: "Mensaje enviado",
      sms_time: "5:44 PM",
      cal_title: "Calendario del Trabajo",
      cal_range: "20 mayo – 26 mayo, 2025",
      cal_week: "Semana", cal_month: "Mes",
      cal_days: ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"],
      cal_evts: ["Pisos", "Visita", "Material", "Inspección", "Llamada", "Recorrido"],
      manuel_voice: "Levi, envíale a Manuel la orden de trabajo en español, por favor.",
      manuel_to: "Para: Manuel García",
      manuel_role: "Jefe de Cuadrilla",
      manuel_email_pill: "Correo",
      manuel_body_pre: "Listo para enviar a",
      manuel_body_who: "Manuel García",
      manuel_body_what: "Orden de Trabajo #WO-1298",
      manuel_body_language: "en español.",
      manuel_body_es_verbatim: "Listo para enviar a Manuel García el Work Order #WO-1298 en español.",
      manuel_confirm: "Confirmar y Enviar",
      value: [
        { t: "Cumple con el calendario.", b: "Levi gestiona tu calendario y te recuerda lo que viene." },
        { t: "Mantén al cliente informado.", b: "Las actualizaciones y recordatorios salen automáticamente — por correo o texto." },
        { t: "Equipa a tu cuadrilla.", b: "Envía órdenes de trabajo, listas y instrucciones en segundos." },
        { t: "Nunca pierdas nada.", b: "Levi registra la actividad y marca lo que necesita tu atención." },
        { t: "Los trabajos siguen avanzando.", b: "Menos idas y vueltas. Más hecho. Más ganancia." },
      ],
    },
    handle: {
      h2a: "Maneja el", h2b: "negocio.",
      lede: "Levi te ayuda a cobrar, hacer seguimiento a la rentabilidad, cerrar trabajos y mantener tu negocio fuerte y en crecimiento.",
      c1_title: "Facturas y Pagos",
      c1_body: "Envía facturas profesionales, registra los pagos recibidos fuera de la app y da seguimiento a lo pendiente.",
      c2_title: "Información de Rentabilidad",
      c2_body: "Conoce exactamente cómo se desempeñó cada trabajo en tiempo real.",
      c3_title: "Documentos de Cierre",
      c3_body: "Crea y envía la documentación completa de cierre del proyecto.",
      c4_title: "Garantías y Seguimiento",
      c4_body: "Guarda garantías, entrégalas cuando se necesiten y gestiona el seguimiento post-trabajo.",
      cta: "Agenda una Demo",
      voice: "Levi, ¿cuál fue nuestra rentabilidad en el re-estuco exterior de la casa Jones?",
      reply_pre: "Terminaste el",
      reply_mid: "trabajo de Jones con un margen del 31.6%",
      reply_post: ", con",
      reply_profit: "$5,930 de ganancia",
      reply_end: ".",
      panel_title: "Re-Estuco Exterior Jones",
      panel_status: "Completado",
      panel_contract: "Contrato",
      panel_actual: "Costo Real",
      panel_profit: "Ganancia",
      panel_margin_label: "Margen de Ganancia",
      panel_date_label: "Fecha del Trabajo",
      panel_date_value: "5 mayo – 28 mayo, 2025",
      panel_customer_label: "Cliente",
      panel_customer_value: "Jones",
      invoices_title: "Facturas Recientes",
      invoices_view: "Ver todas",
      inv_paid: "Pagado",
      inv_partial: "Parcial",
      inv_unpaid: "Sin Pagar",
      inv_names: {
        i1: "Re-Estuco Exterior Jones",
        i2: "Reemplazo de Techo Smith",
        i3: "Pintura Interior Anderson",
      },
      value: [
        { t: "Cobra más rápido.", b: "Envía facturas profesionales y da seguimiento a los pagos registrados fuera de la app." },
        { t: "Conoce tus números.", b: "Información en tiempo real de rentabilidad por trabajo, cliente y período." },
        { t: "Cierra con confianza.", b: "Crea documentos de cierre completos y mantén cada trabajo documentado." },
        { t: "Protege tu trabajo.", b: "Guarda garantías, entrégalas automáticamente y fortalece la confianza del cliente." },
        { t: "Construye un negocio más fuerte.", b: "Mayor visibilidad. Más ganancia. Clientes más felices. Más crecimiento." },
      ],
    },
    talk: {
      h2a: "Habla con Levi.", h2b_pre: "Muéstrale", h2b_blue: "el trabajo.",
      lede: "Habla naturalmente por voz o texto mientras Levi Vision te ayuda a capturar y entender lo que está pasando en el trabajo. Recorre el proyecto, toma fotos y video, dale a Levi tus medidas, y él te ayuda a verificarlas e identificar lo que puede estar faltando.",
      c1_title: "Voz y Texto",
      c1_body: "Habla naturalmente, obtén respuestas y sigue trabajando.",
      c2_title: "Manos Libres",
      c2_body: "Usa la voz en el sitio de trabajo mientras tus manos quedan libres.",
      c3_title: "Inglés y Español",
      c3_body: "Levi habla tu idioma.",
      c4_title: "Levi Vision",
      c4_body: "Recorre el trabajo, toma fotos y video, y añade notas.",
      c5_title: "Verificar Medidas",
      c5_body: "Revisa las medidas y confirma lo que se ve bien.",
      c6_title: "Identificar Faltantes",
      c6_body: "Levi ayuda a detectar lo que puede estar faltando antes de que te cueste.",
      cta: "Agenda una Demo",
      contractor_voice: "Levi, tengo esta pared a unos 9 pies 4 pulgadas. ¿Se ve bien?",
      levi_verify: "Esa medida se ve consistente con lo que estoy viendo.",
      levi_observation: "También noté una abertura de ventana que puede que haya que tener en cuenta.",
      chip_bar: ["Voz y Texto", "Manos Libres", "Inglés y Español", "Fotos y Video", "Verificar Medidas", "Identificar Faltantes"],
      opening_title: "Abertura Detectada",
      opening_kind: "Abertura de Ventana",
      opening_size: "Aprox. 3' 6\" x 4' 2\"",
    },
    proof_stamp: "PROOF DE DISEÑO · no es una ruta de producción · Landing.jsx sin cambios · nav sin cambios · sin commit.",
    demo: {
      eyebrow: "Conoce a Levi en acción",
      h1: "Descubre cómo Levi te ayuda a manejar tu negocio de forma más inteligente.",
      subhead: "JobClose AI y Levi ayudan a los contratistas a ahorrar tiempo, ganar más trabajos y cerrar con confianza. Cuéntanos un poco sobre ti y te contactaremos para agendar tu demostración personalizada.",
      hero_img_alt: "Levi, la mascota de JobClose AI, con su gorra aprobada de JobClose AI y su placa de collar «Levi», sentado en un escritorio de contratista junto a una taza de JobClose AI, una cinta métrica y un juego de planos.",
      bullets: [
        { title: "Ahorra tiempo", body: "Automatiza el trabajo repetitivo y recupera horas de tu día." },
        { title: "Gana más trabajos", body: "Estimaciones precisas y propuestas profesionales en minutos." },
        { title: "Cierra con confianza", body: "Mantente organizado, comunica con claridad y cobra más rápido." },
      ],
      form_title: "Solicita una demostración",
      form_subtitle: "Cuéntanos un poco sobre ti y te contactaremos para agendar tu demostración personalizada.",
      f_full_name: "Nombre completo",
      f_company_name: "Nombre de la empresa",
      f_work_email: "Correo del trabajo",
      f_phone: "Número de teléfono",
      f_trade: "Oficio / tipo de negocio",
      f_state: "Estado",
      f_preferred_contact: "Método de contacto preferido",
      f_message: "¿Qué te gustaría ver en la demostración?",
      ph_full_name: "Tu nombre",
      ph_company_name: "Tu empresa",
      ph_work_email: "tu@empresa.com",
      ph_phone: "(555) 555-5555",
      ph_trade: "Selecciona tu oficio",
      ph_state: "Selecciona tu estado",
      ph_message: "Cuéntanos qué es lo más importante para tu negocio…",
      optional: "opcional",
      pref_labels: { phone: "Llamada", text: "Mensaje de texto", email: "Correo" },
      submit: "Solicita una demostración",
      submitting: "Enviando…",
      form_privacy_note: "Tu información es segura y nunca la compartiremos.",
      err_required: "Por favor completa este campo.",
      err_email: "Ingresa un correo del trabajo válido.",
      err_phone: "Ingresa un número de teléfono válido.",
      toast_sent: "¡Gracias! Recibimos tu solicitud.",
      toast_failed: "Algo salió mal. Inténtalo de nuevo.",
      toast_rate_limited: "Demasiadas solicitudes — inténtalo en un momento.",
      success_title: "Gracias — recibimos tu solicitud.",
      success_body: "Alguien de JobClose AI se comunicará contigo pronto para agendar tu demostración personalizada en un horario que te acomode.",
      value_heading: "En tu demostración te mostraremos:",
      value_tiles: [
        { title: "Tu flujo de trabajo", body: "Cómo JobClose AI se adapta a tu proceso, de principio a fin." },
        { title: "Funciones clave", body: "Las herramientas que te ahorran tiempo y hacen crecer tu negocio." },
        { title: "Levi en acción", body: "Cómo Levi te ayuda a obtener respuestas y tomar acción." },
        { title: "Tus preguntas", body: "Nos enfocamos en lo que más importa para ti." },
      ],
      faq_eyebrow: "Preguntas frecuentes",
      faq_heading: "Preguntas Frecuentes",
      faqs: [
        { q: "¿Qué veré durante la demostración?", a: "Nos enfocamos en cómo JobClose AI y Levi funcionan en el flujo del contratista — desde entender el trabajo hasta cerrarlo — y dedicamos más tiempo a las áreas que más te importan." },
        { q: "¿Cuánto dura la demostración?", a: "La mayoría dura unos 30 minutos. Si tienes mucho que cubrir, con gusto extendemos el tiempo." },
        { q: "¿Para quién está hecho JobClose AI?", a: "Para contratistas de campo y cuadrillas pequeñas en oficios como techado, pintura, pisos, remodelación, concreto, HVAC y más. Si estimas, ejecutas y cierras trabajos, JobClose AI es para ti." },
        { q: "¿Necesito preparar algo antes de la demostración?", a: "No. Solo trae tus preguntas. Si hay algo específico que quieras ver, cuéntanoslo en el formulario y estaremos listos." },
        { q: "¿Pueden mostrarme cómo trabajaría Levi con mi negocio?", a: "Sí. Levi es una parte central de JobClose AI, y te mostramos cómo los contratistas lo usan durante el día — voz, fotos, planos, estimaciones, propuestas, facturas y seguimientos." },
        { q: "¿JobClose AI sirve para diferentes oficios?", a: "Sí. Tus precios, tus oficios, tu flujo. Levi se adapta a cómo ya manejas tu negocio en lugar de imponer una plantilla única." },
        { q: "¿Cuánto cuesta JobClose AI?", a: "JobClose AI cuesta $129/mes e incluye dos usuarios completos. Cada usuario adicional cuesta $20/mes. La incorporación estándar está incluida. No hay niveles artificiales ni complementos requeridos — recibes toda la experiencia de JobClose AI y Levi con todo incluido." },
      ],
      final_title: "¿Listo para ver a Levi trabajar como tú trabajas?",
      final_body: "Completa el formulario arriba y nos comunicaremos contigo para agendar tu demostración.",
      final_cta: "Solicita una demostración",
    },
  },
};
